/**
 * The founder's booking page. Single source of truth for every "book a call" CTA.
 *
 * This lives in shared/ (not in the client component) because the /features/*
 * content files under shared/featureContent also point their secondary CTA at
 * it, and the server-side SEO/JSON-LD builder imports the same content. The
 * client component client/src/components/website/FounderCall.tsx re-exports
 * these, so existing UI imports keep working.
 */
export const FOUNDER_CALL_URL = 'https://www.cal.eu/talenture/30min?overlayCalendar=true';

export const FOUNDER_CALL_LABEL = 'Book 15 minutes with the founder';
